import { render, staticRenderFns } from "./productTableClassic.vue?vue&type=template&id=d28ea06c&scoped=true&"
import script from "./productTableClassic.vue?vue&type=script&lang=js&"
export * from "./productTableClassic.vue?vue&type=script&lang=js&"
import style0 from "./productTableClassic.vue?vue&type=style&index=0&id=d28ea06c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28ea06c",
  null
  
)

export default component.exports